var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form-item',{staticClass:"form_radio",attrs:{"label":_vm.$attrs.label}},[_c('div',{staticClass:"radio__inner"},_vm._l((_vm.getOptions),function(val,idx){return _c('van-button',{key:`col_${ idx }`,staticClass:"float-left",class:{
				round:_vm.round,
				plain:_vm.plain,
			},attrs:{"type":_vm.modelValue === val.value ? 'primary' : 'default',"plain":""},on:{"click":function($event){_vm.modelValue = val.value}}},[_vm._v(" "+_vm._s(val.label)+" ")])}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }